import {
  getNotifications as callGetNotifications,
  putNotifications,
} from '../../../api/preference';
import { openAlert } from './alertActions';

const BASE = 'notifications/';

export const preferenceActionTypes = {
  getNotificationsStart: `${BASE} fetch start`,
  getNotificationsSuccess: `${BASE} fetch SUCCESS`,
  getNotificationsFailed: `${BASE} fetch FAILED`,

  changeNotificationsStart: `${BASE} persist start`,
  changeNotificationsSuccess: `${BASE} persist SUCCESS`,
  changeNotificationsFailed: `${BASE} persist FAILED`,
};

export const getNotifications = () => async (dispatch) => {
  dispatch({
    type: preferenceActionTypes.getNotificationsStart,
  });
  try {
    const {
      lunchArrivalPushNotificationDisabled,
      lunchArrivalSmsDisabled,
      lunchArrivalEmailDisabled,
      marketingEmailDisabled,
      shuttleReminderEmailDisabled,
    } = await callGetNotifications();
    dispatch({
      type: preferenceActionTypes.getNotificationsSuccess,
      lunchArrivalPushNotificationDisabled,
      lunchArrivalSmsDisabled,
      lunchArrivalEmailDisabled,
      marketingEmailDisabled,
      shuttleReminderEmailDisabled,
    });
  } catch (e) {
    dispatch(
      openAlert({
        message: 'Failed to retrieve notifications',
        variant: 'error',
      })
    );
    dispatch({
      type: preferenceActionTypes.getNotificationsFailed,
    });
  }
};

/**
 *
 * @param {PreferenceState.Preference} preferences
 * @param {number} mixpanelDistinctId
 */
export const changeNotifications = (preferences, mixpanelDistinctId) => async (dispatch) => {
  dispatch({
    type: preferenceActionTypes.changeNotificationsStart,
  });
  try {
    await putNotifications(preferences, mixpanelDistinctId);
    dispatch(
      openAlert({
        message: 'Save notifications successfully',
        variant: 'success',
      })
    );
    dispatch({
      type: preferenceActionTypes.changeNotificationsSuccess,
      ...preferences,
    });
  } catch (e) {
    dispatch(
      openAlert({
        message: 'Failed to save notifications',
        variant: 'error',
      })
    );
    dispatch({
      type: preferenceActionTypes.changeNotificationsFailed,
    });
  }
};
